import { CommonModule } from "@angular/common";
import { Component, inject, signal } from "@angular/core";
import { ModalComponent } from "@evc/web-components";
import { TranslatePipe } from "@ngx-translate/core";
import { AssetsIntroductionComponent } from "../assets-introduction/assets-introduction.component";
import { EVC_MODAL_REF } from "../../../../_shared/services/modal/evc-modal.service";

@Component({
  selector: "app-migration-progress-modal",
  standalone: true,
  imports: [CommonModule, ModalComponent, TranslatePipe, AssetsIntroductionComponent],
  templateUrl: "./migration-progress-modal.component.html",
  styleUrls: ["./migration-progress-modal.component.scss"]
})
export class MigrationProgressModalComponent {
  private modalRef = inject(EVC_MODAL_REF);
  public isCompleted = signal(false);

  onClose() {
    this.modalRef.close();
    localStorage.setItem("first-visit-asset-module", Date.now().toString());
  }
}
